import {Button} from "antd";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const BackButton = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()


    return (
        <Button type={'default'} shape={'round'} onClick={e => navigate(-1)}>{t('back')}</Button>
    )
}

export default BackButton;